import React, { useState ,useEffect} from "react";
import {
  Box,
  Typography,
  Container,
  TextField,
  Button,
  Stepper,
  StepLabel,
  Step,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { baseapi } from "../../Environmentalurl";
import { ApplicationType, entity_id, getGeolocation, Platform } from "../../Utils/Const";
import useIPAddress from "../../Utils/useIPAddress";
import api from "../../Utils/Api";

export default function Fse() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [tpin, setTpin] = useState("");
  const [confirmTpin, setConfirmtpin] = useState("");
  const location = useLocation();
  const profileData = location.state;

 const ip = useIPAddress();
  console.log(profileData.mobile);

  const navigate = useNavigate();

  const steps = [
    "Mobile verification",
    "Profile Details",
    "Security Checkup",
    "Complete",
  ];

  const handleSubmit = async () => {
    try {
      const payload = {
        ReqType: "MT_Reg_walletenroll",
        ApplicationType: ApplicationType,
        Statement: "Enroll",
        MachineID: ip,
        Platform: Platform,
        MobileNumber: profileData.mobile,
        RegisteredbyMobile: profileData.mobile,
        Poiemail: profileData.email,
        EntityID: entity_id,
        isMobileNumberVerified: 0,
        SSOID: "-",
        MemberID: "",
        POIType:
          profileData.idType === "Aadhaar"
            ? "aadhaar number"
            : "Driving License",
        POAType:
          profileData.idType === "Aadhaar" ? "Aadhaar" : "Driving License",

        POI: profileData.idNumber,
        POA: profileData.idNumber,

        POIVerified:
          profileData.idType === "Aadhaar" && profileData.aadhaarStatus === 1
            ? 1
            : 0,

        POAVerified: 0,
        KYCStatus: 2,
        PAN: "",
        FirstName: profileData.firstName,
        LastName: profileData.lastName,
        Poiname: `${profileData.firstName} ${profileData.lastName}`,
        Poidob: profileData.dob,
        Poigender: profileData.gender,

        TPIN: confirmTpin,

        WalletTypeID: 1,

        PDBankAccountHolderName: "",
        PDBankName: "",
        PDBankIFSC: "",
        PDBankAccountNo: "",

        Geolocation: await getGeolocation(),
      };

      console.log("Submitting Payload:", payload);

      const response = await api.post(`${baseapi}/auth/registration`, payload);

      if (response.data.Response_Code === "1000") {
        navigate("/registration/lowkyc/success-tpin");
      } else {
        alert(response.data.Message);
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong while registering");
    }
  };

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: "#f5f7f6", p: 6 }}>
        <Box sx={{ bgcolor: "#f5f7f6", minHeight: "100vh" }}>
          <Container maxWidth="md">
            <Box
              sx={{
                bgcolor: "white",
                borderRadius: 3,
                boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                display: "flex",
                overflow: "hidden",
              }}
            >
              {/* Left Illustration */}
              <Box
                sx={{
                  width: "40%",
                  bgcolor: "#0aa34f",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 4,
                }}
              >
                <Box
                  component="img"
                  src="/Assets/image.png"
                  sx={{ width: "100%", maxWidth: 260 }}
                />
              </Box>

              {/* Right Content */}
              <Box sx={{ width: "60%", p: 5 }}>
                <Typography
                  sx={{
                    cursor: "pointer",
                    mb: 2,
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#3d7f45",
                    fontWeight: 500,
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() =>
                    navigate("/registration/lowkyc/profiledetails")
                  }
                >
                  ← Back
                </Typography>

                {/* Stepper */}
                <Stepper activeStep={2} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                <Typography
                  variant="h5"
                  fontWeight="bold"
                  mt={4}
                  mb={3}
                  textAlign="center"
                >
                  Set TPIN
                </Typography>

                <Typography>Enter TPIN</Typography>
                <TextField
                  label="Enter TPIN"
                  fullWidth
                  sx={{ mb: 3 }}
                  value={tpin}
                  onChange={(e) => setTpin(e.target.value)}
                />

                <Typography>Confirm TPIN</Typography>
                <TextField
                  label="Confirm TPIN"
                  fullWidth
                  sx={{ mb: 3 }}
                  value={confirmTpin}
                  onChange={(e) => setConfirmtpin(e.target.value)}
                />

                <Button
                  fullWidth
                  sx={{
                    mt: 2,
                    bgcolor: "#0aa34f",
                    color: "white",
                    py: 1.5,
                    fontSize: 16,
                    "&:hover": { bgcolor: "#0aa34f" },
                  }}
                  variant="contained"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
